export const validation = {
  nameRequired: 'Please enter role name',
  nameMax: 'Please enter role name less than 30 characters',
  nameAph  : 'Please enter valid role name',
  typeRequired: 'Please select type',
  countryId: 'Country is required',
  locationFor: 'Role is required',
  pullPermitCost: 'Pull permit cost is required',
};
